import { FaCircleCheck } from 'react-icons/fa6';
import { toast, Slide } from 'react-toastify';

export const showToastSuccess = (
    message: string,
) => {

    toast.success(
        message,
        {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            closeButton: false,
            transition: Slide,
            style: {
                fontSize: "16px",
                color: "#000000",
                width: "100%",
                whiteSpace: "nowrap",
                wordBreak: "break-word",
            },
            icon: <FaCircleCheck size={24} style={{ color: "#52DF77" }} />
        }
    );
};
